export default "__VITE_ASSET__df5f09d8__"